export const PUZZLE_IMAGES = Array.from({ length: 40 }, (_, index) => {
  const number = index + 1;
  return {
    id: `img_${number}`,
    nome: `Imagem ${number}`,
    url: `/imagens/quebra-cabeca/${number}.jpg`,
  };
});
